<template>
  <div class="home-page">
    <!-- Dialog mejorado para banner -->
    <v-dialog
      v-model="dialog_banner"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="banner-dialog"
    >
      <v-card class="banner-card">
        <v-toolbar dark color="orange" class="banner-toolbar">
          <v-btn icon dark @click="dialog_banner = false" class="close-button">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title class="banner-title">Banner del Evento</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="banner-container">
          <v-img
            alt="Banner Evento"
            :src="src_banner"
            contain
            class="banner-image"
          ></v-img>
        </div>
      </v-card>
    </v-dialog>

    <!-- Hero Section -->
    <section class="hero-section">
      <v-container>
        <v-layout
          column
          align-center
          justify-center
          class="hero-content"
        >
          <div class="logo-container">
            <v-img
              alt="Logo Finishtime"
              :src="logo"
              aspect-ratio="1"
              height="200px"
              width="200px"
              class="logo-image"
            ></v-img>
          </div>
          <h1 class="hero-title">
            Inscripciones
          </h1>
          <p class="hero-subtitle">
            Encuentra y participa en los mejores eventos deportivos
          </p>
        </v-layout>
      </v-container>
    </section>

    <section class="events-section">
      <v-container>
        <div class="section-header">
          <div class="section-title-container">
            <v-icon large color="orange" class="section-icon">calendar_today</v-icon>
            <h2 class="section-title">Próximos Eventos</h2>
          </div>
          <p class="section-description">Descubre los eventos que están por venir</p>
        </div>

        <!-- Loading State -->
        <div v-if="eventosLoading" class="loading-container">
          <v-progress-circular
            :size="60"
            :width="5"
            color="orange"
            indeterminate
            class="loading-spinner"
          ></v-progress-circular>
          <p class="loading-text">Cargando eventos...</p>
        </div>

        <!-- Empty State -->
        <div v-else-if="!eventosLoading && items.length === 0" class="empty-state">
          <v-icon large color="grey lighten-1" class="empty-icon">event_busy</v-icon>
          <h3 class="empty-title">No hay eventos próximamente</h3>
          <p class="empty-description">Vuelve pronto para ver nuevos eventos disponibles</p>
        </div>

        <!-- Events Grid -->
        <div v-else class="events-grid">
          <transition-group name="fade-stagger" tag="div" class="events-grid-inner">
            <div
              v-for="val in items"
              :key="val.id"
              class="event-card-wrapper"
            >
              <EventoCard
                :val="val"
                @showBanner="showBanner"
                :pasado="false"
              />
            </div>
          </transition-group>
        </div>
      </v-container>
    </section>

    <!-- Eventos Pasados Section -->
    <section v-if="items_pasados.length > 0" class="events-section past-events-section">
      <v-container>
        <div class="section-header">
          <div class="section-title-container">
            <v-icon large color="grey darken-1" class="section-icon">history</v-icon>
            <h2 class="section-title">Eventos Pasados</h2>
          </div>
          <p class="section-description">Revisa eventos anteriores y sus resultados</p>
        </div>

        <div class="events-grid">
          <transition-group name="fade-stagger" tag="div" class="events-grid-inner">
            <div
              v-for="val in items_pasados"
              :key="val.id"
              class="event-card-wrapper"
            >
              <EventoCard
                :val="val"
                @showBanner="showBanner"
                :pasado="true"
              />
            </div>
          </transition-group>
        </div>

        <!-- Ver Más Button -->
        <div class="load-more-container">
          <v-btn
            :loading="verMasLoading"
            large
            outlined
            color="orange"
            class="load-more-button"
            @click="loadNextPage"
          >
            <v-icon left>expand_more</v-icon>
            Ver Más Eventos
          </v-btn>
        </div>
      </v-container>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventoCard from '@/components/EventoCard';

export default {
  components: {
    EventoCard
  },

  data() {
    return {
      logo: 'logo.png',
      image_url: './logo',
      eventosLoading: false,
      verMasLoading: false,
      dialog_banner: false,
      src_banner: ''
    }
  },

  props: {
    source: String
  },

  computed: mapState({
    items: state => state.eventos.eventos_visibles,
    items_pasados: state => state.eventos.eventos_visibles_pasados
  }),

  created() {
    this.eventosLoading = true;
    this.$store.dispatch('eventos/getAllEventos').then(() => {
      this.eventosLoading = false;
    })
  },

  methods: {
    showBanner(src) {
      this.src_banner = src;
      this.dialog_banner = true;
    },

    loadNextPage() {
      this.verMasLoading = true
      this.$store.dispatch('eventos/loadEventosPasadosNextPage').then(() => {
        this.verMasLoading = false;
      })
    },

    inscripcionProxima(e) {
      return new Date() < new Date(e.fecha_inicio_inscripcion)
    },

    inscripcionPasada(e) {
      return new Date() > new Date(e.fin_inscripcion)
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
}

/* Hero Section */
.hero-section {
  padding: 40px 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  border-bottom: 1px solid #e0e0e0;
}

.hero-content {
  text-align: center;
}

.logo-container {
  margin-bottom: 24px;
  animation: fadeInDown 0.6s ease-out;
}

.logo-image {
  width: 200px;
  height: 200px;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
  transition: transform 0.3s ease;
}

.logo-image:hover {
  transform: scale(1.05);
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 300;
  color: #ff4900;
  margin-bottom: 12px;
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: #757575;
  font-weight: 400;
  max-width: 600px;
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

/* Events Section */
.events-section {
  padding: 60px 0;
}

.past-events-section {
  background-color: #fafafa;
  padding-top: 40px;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 12px;
}

.section-icon {
  animation: pulse 2s ease-in-out infinite;
}

.section-title {
  font-size: 2rem;
  font-weight: 600;
  color: #212121;
  margin: 0;
}

.section-description {
  font-size: 1rem;
  color: #757575;
  margin: 0;
  max-width: 500px;
  margin: 0 auto;
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  gap: 20px;
}

.loading-spinner {
  margin-bottom: 16px;
}

.loading-text {
  color: #757575;
  font-size: 1rem;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
}

.empty-icon {
  margin-bottom: 20px;
  opacity: 0.5;
}

.empty-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #424242;
  margin-bottom: 8px;
}

.empty-description {
  font-size: 1rem;
  color: #757575;
  max-width: 400px;
}

/* Events Grid */
.events-grid {
  width: 100%;
}

.events-grid-inner {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  width: 100%;
}

.event-card-wrapper {
  width: 100%;
}

/* Fade Stagger Animation */
.fade-stagger-enter-active {
  transition: all 0.5s ease;
}

.fade-stagger-leave-active {
  transition: all 0.3s ease;
}

.fade-stagger-enter {
  opacity: 0;
  transform: translateY(20px);
}

.fade-stagger-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-stagger-move {
  transition: transform 0.5s ease;
}

/* Load More Button */
.load-more-container {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  padding: 20px 0;
}

.load-more-button {
  min-width: 200px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  border-radius: 28px;
  padding: 12px 32px;
  transition: all 0.3s ease;
}

.load-more-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 73, 0, 0.3);
}

/* Banner Dialog */
.banner-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.banner-toolbar {
  flex-shrink: 0;
}

.banner-title {
  font-weight: 600;
}

.close-button {
  transition: transform 0.2s ease;
}

.close-button:hover {
  transform: rotate(90deg);
}

.banner-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow: auto;
  background-color: #f5f5f5;
}

.banner-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* Animations */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Mobile First - Responsive */
@media (max-width: 600px) {
  .hero-section {
    padding: 30px 0;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
    padding: 0 20px;
  }

  .logo-image {
    width: 150px !important;
    height: 150px !important;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .events-section {
    padding: 40px 0;
  }

  .events-grid-inner {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .load-more-button {
    width: 100%;
    max-width: 300px;
  }
}

@media (min-width: 960px) {
  .events-grid-inner {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
}

@media (min-width: 1264px) {
  .events-grid-inner {
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  }
}
</style>
